import Landing from "./Landing";
import NarrativeComponent from "./NarrativeComponent";
import NarrativeTitle from "./NarrativeTitle";
import TextComponent from "./TextComponent";
import LargeTextComponent from "./LargeTextComponent";
import VideoComponent from "./VideoComponent";
import PressComponent from "./PressComponent";
import FooterComponent from "./FooterComponent";
import GalleryComponent from "./GalleryComponent";
import PhotoGridComponent from "./PhotoGridComponent";
import "./styles.css";

export default function App() {
  return (
    <div className="main-container">
      <Landing
        imageUrl="https://cdn.builder.io/api/v1/image/assets/TEMP/e243515faa507c2964e5d6e852839cfc238d94a36148702e9f371843f7af1e9f?apiKey=f36dfddbd9034415a16246345aea3c61&"
        description="A future where technology clings to the memory of nature's touch."
      />
      <TextComponent
        height="100dvh"
        text="In the dystopian world of 2124, the Last Plant Alive installation stands as a stark monument to the Earth’s final breaths of natural life. 

\n It’s a world where a singular real plant survives, encircled by its motorised counterparts, a beacon of what once was—a poignant reminder of the world that could be if we fail to act in defence of our planet’s dwindling biodiversity."
      />
      <NarrativeTitle
        title="THE NARRATIVE"
        text="A Trilogy of Desolation and Hope"
      />
      <NarrativeComponent
        text="Visitors step into a dystopian chamber, dimly lit by a single spotlight over the last natural relic—a tiny potted plant. They see a defiant burst of green against the shadowed room created by its leaves. Around flowering vines crafted from iridescent film glimmer with an otherworldly light, a synthetic mimicry of life’s enduring dance. 
        
        \n The air? Heavy with the scent of mustiness and lost time."
        img="https://i.ibb.co/Hh1sNj5/home.jpg"
        heading="1   /  The Sanctuary of Solitude"
      />
      <NarrativeComponent
        text="
        As guests traverse the space, their movements awaken a sprawling projection of a green vine on the floor. The vines come alive with a dance of defiance that you couldn’t define in patterns. This digital flora, serene in its natural hue, reacts in a violent rejection to humans, flaring into a distressing red as it disapproves their presence. 
        
        \n The body presents a visceral display, while the soul silently cries for help. On the surface, it’s a vivid manifestation of nature’s painful memory, enduring centuries of human cruelty. Yet deep within, it’s a digital plea to conserve what little remains."
        img="https://i.ibb.co/FwnVLD5/f17d3f74-b861-4ab7-8b34-836db7a0b799-1.jpg"
        heading="2  /  The Reactive Vineyard"
      />
      <NarrativeComponent
        text="Approaching the heart of the installation, visitors encounter four artillery-like podiums, each cradling a mechanical flower. These artificial blooms, with motors exposed like the inner workings of a clock, scowl at the presence of the onlookers. One begins to quiver and convulse, petals opening and closing in a frenzied attempt to shield the last plant. The origami vines pulse rapidly, a state of alarm echoing through the artifice.  "
        img="https://i.ibb.co/qDQnC10/IMG-20240718-15004807.jpg"
        heading="3  /  The Mechanical Guardians"
      />
      <LargeTextComponent
        text="It’s a clear message: 
        \n Humanity is no longer a caretaker but a threat."
        align="center"
      />
      <VideoComponent />
      <LargeTextComponent text="This immersive experience is a metaphor for the delicate balance between nurture and nature, and a reminder of the retreat of the natural world in the face of human advancement. " />
      <NarrativeComponent
        text="Each step taken within the installation is a reflection on life’s fragility and the relentless quest to replicate its beauty. It urges visitors to contemplate their environmental footprint and the legacy they wish to leave behind. It aims to evoke a sense of urgency and responsibility, encouraging visitors to engage with themes of sustainability and conservation in a deeply personal way."
        img="https://i.ibb.co/Bs1D9vJ/Screenshot-2024-07-27-005239.png"
        heading=""
      />
      <PhotoGridComponent />
      <LargeTextComponent
        text="The Last Plant Alive is a poignant reminder that even in a dystopian future, there is still a chance for redemption and rebirth."
        align="center"
      />
      <GalleryComponent />

      <PressComponent />
      <FooterComponent
        text='The Last Plant Alive is conceptualised by Abhishek , Mohak and Shreni ; mentored by Somil Mehta and Vinay Khare.  The project was initially showcased as part of "Lost in Bangalore," a month-long New Media Arts exhibition by Sensistan, where it received positive feedback. 

        \n The team is eager to share this exhibit with a wider audience and are thrilled to see it evolve and flourish as it travels to new locations and finds new homes.'
      />
    </div>
  );
}
